import { TYPES } from "./bailiff_job.type";
import {
  onSnapshot,
  query,
  where,
  getCountFromServer,
} from "firebase/firestore";
//func
import { getRefs } from "../ref";
import { getAuth } from "firebase/auth";

// ========= firebase function =========//

//snap all provider
const allBailiffJobSub = [];
export const snapBailiffJob = (callback) => (dispatch) => {
  setBailiffJobAllSuccess(dispatch, null);
  const cRef = getRefs().job;
  const uid = getAuth().currentUser?.uid;
  const c0 = where("status", "!=", "paid");
  const c1 = where("client", "==", uid);
  const qRef = query(cRef, c0, c1);
  const unsub = onSnapshot(qRef, (snapshot) => {
    if (snapshot) {
      const data = snapshot.docs.map((doc) => doc.data());
      console.log({ data });
      setBailiffJobAllSuccess(dispatch, data);
      if (callback) {
        callback();
      }
    }
  });
  allBailiffJobSub.push(unsub);
};

export const unSnapBailiffJob = () => (dispatch) => {
  allBailiffJobSub.forEach((subscriber) => {
    subscriber();
  });
  allBailiffJobSub.length = 0;
};

// count extracting
export const firebaseCountExtracting = () => (dispatch) => {
  setBailiffJobExtractingCountSuccess(dispatch, 0);
  const cRef = getRefs().job;
  const uid = getAuth().currentUser?.uid;
  const c0 = where("status", "==", "extracting");
  const c1 = where("client", "==", uid);
  const qRef = query(cRef, c0, c1);
  getCountFromServer(qRef).then((snapshot) => {
    if (snapshot) {
      const count = snapshot?.data().count;
      setBailiffJobExtractingCountSuccess(dispatch, count);
    }
  });
};

//snap detail job
const bailiffDetailJobSub = [];
export const snapBailiffJobById =
  ({ id }, callback) =>
  (dispatch) => {
    setBailiffJobDetailSuccess(dispatch, null);
    const cRef = getRefs().job;
    const uid = getAuth().currentUser?.uid;
    const c0 = where("client", "==", uid);
    const c1 = where("id", "==", id);
    const qRef = query(cRef, c0, c1);
    const unsub = onSnapshot(qRef, (snapshot) => {
      if (snapshot) {
        const data = snapshot.docs?.map((doc) => doc.data());
        const detail = data?.length > 0 ? data[0] : null;
        setBailiffJobDetailSuccess(dispatch, detail);
        if (callback) {
          callback();
        }
      }
    });
    bailiffDetailJobSub.push(unsub);
  };

export const unSnapBailiffJobById = () => (dispatch) => {
  bailiffDetailJobSub.forEach((subscriber) => {
    subscriber();
  });
  bailiffDetailJobSub.length = 0;
};

// check xem coi có được add job không.
export const checkPossibleToAddJob = async ({ max }) => {
  const cRef = getRefs().job;
  const uid = getAuth()?.currentUser?.uid;
  const c0 = where("client", "==", uid);
  const c1 = where("status", "in", ["processing", "waiting"]);
  const qRef = query(cRef, c0, c1);
  return getCountFromServer(qRef).then((snapshot) => {
    if (snapshot) {
      const count = snapshot.data().count;
      console.log({ count });
      if (count <= max) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  });
};
// ========= fetch api =========//
export const getBankData = () => async (dispatch) => {
  const response = await fetch("https://api.vietqr.io/v2/banks").then((res) =>
    res?.json(),
  );
  if (response.code !== "00") {
    setBailiffJobBanksSuccess(dispatch, []);
  }

  const data = response?.data;
  setBailiffJobBanksSuccess(dispatch, data);
};
// ========= cloud function =========//
// ========= local function =========//
export const setBailiffJobAll = (data, callback) => (dispatch) => {
  setBailiffJobAllSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setBailiffJobOpenAdd = (data, callback) => (dispatch) => {
  setBailiffJobOpenAddSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setBailiffJobOpenEdit = (data, callback) => (dispatch) => {
  setBailiffJobOpenEditSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setBailiffJobSelected = (data, callback) => (dispatch) => {
  setBailiffJobSelectedSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setBailiffJobSearch = (data, callback) => (dispatch) => {
  setBailiffJobSearchSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setBailiffJobDetail = (data, callback) => (dispatch) => {
  setBailiffJobDetailSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setBailiffJobPreview = (data, callback) => (dispatch) => {
  setBailiffJobPreviewSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setBailiffJobOpenPayment = (data, callback) => (dispatch) => {
  setBailiffJobOpenPaymentSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

// ========= dispatch =========//

const setBailiffJobAllSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_BAILIFF_JOB_ALL,
    payload: data,
  });
};

const setBailiffJobOpenAddSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_BAILIFF_JOB_OPEN_ADD,
    payload: data,
  });
};

const setBailiffJobOpenEditSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_BAILIFF_JOB_OPEN_EDIT,
    payload: data,
  });
};

const setBailiffJobSelectedSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_BAILIFF_JOB_SELECTED,
    payload: data,
  });
};

const setBailiffJobSearchSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_BAILIFF_JOB_SEARCH,
    payload: data,
  });
};

const setBailiffJobDetailSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_BAILIFF_JOB_DETAIL,
    payload: data,
  });
};

const setBailiffJobOpenPaymentSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_BAILIFF_JOB_OPEN_PAYMENT,
    payload: data,
  });
};

const setBailiffJobBanksSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_BAILIFF_JOB_BANKS,
    payload: data,
  });
};

const setBailiffJobPreviewSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_BAILIFF_JOB_PREVIEW,
    payload: data,
  });
};

const setBailiffJobExtractingCountSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_BAILIFF_JOB_EXTRACTING_COUNT,
    payload: data,
  });
};
